import type { ConfigNodeType } from '../types/config.types'

export const MODULE_CONFIG_OBJECT_TYPES = new Set<ConfigNodeType>([
  'catalog',
  'document',
  'register',
  'informationRegister',
  'accumulationRegister',
])
